import React from "react";
import "./Shake.css";
const Shake = () => {
  return (
    <section className="shake-wrapper">
      <div className="right-side">
        <p className="project-name">Shake</p>
        <div className="left-side">
          <button type="button">Shake me</button>
          <h1>MianAhmad...</h1>
        </div>
        <div class="universe">
          <div class="sun"></div>
        </div>
      </div>
    </section>
  );
};

export default Shake;
